// PhraseType rows are stored with plain English names ("Phrase"/"Sentence"),
// matching this codebase's existing lookup-table convention (Tense/Form
// names are shown raw/untranslated everywhere too). These two known types
// get a nicer localized tab label; anything added later via
// POST /api/phrase-types (a 3rd type, say) still works - it just falls back
// to its raw name until someone adds an override here, same graceful
// degradation Tense/Form already rely on.
const OVERRIDE_KEYS = { Phrase: 'phraseTypePhrase', Sentence: 'phraseTypeSentence' };

export default function phraseTypeLabel(type, lang) {
   if (!type) return '';
   const key = OVERRIDE_KEYS[type.name];
   return (key && lang[key]) ? lang[key] : type.name;
}
